import { myAxios } from "../../utils/common";

export interface MyProjectReview {
  id: number;
  project_id: number;
  status: "pending" | "answered" | "rejected";
  repo_url: string;
  review_md: string | null;
  reject_reason: string | null;
  created_at: string;
  answered_at: string | null;
}

export async function getMyProjectReviews(): Promise<MyProjectReview[]> {
  const res = await myAxios.get("/project-reviews/mine");
  return res.data;
}

export async function createProjectReview(payload: {
  project_id: number;
  repo_url: string;
  note?: string;
}): Promise<{ id: number; status: string }> {
  const res = await myAxios.post("/project-reviews", payload);
  return res.data;
}
